import request from "../../../utils/request";
import {axiosResponseParser} from "../../../utils/utils";


export const getMeinianOrders = '/order/page?source=美年';
export const getMeinianNewOrders = '/order/page?source=新美年';
export const getYunyigouOrders = '/order/page?source=云医购';

export function getMeinianOrderDetail(id: string) {
    return request.get('/order/queryById', {
        params: {id},
        transformResponse: axiosResponseParser
    });
}

export function getMeinianNewOrderDetail(id: string) {
    return request.get('/order/queryById', {
        params: {id},
        transformResponse: axiosResponseParser
    });
}

export function getYunyigouOrderDetail(id: string) {
    return request.get('/order/queryById', {
        params: {id},
        transformResponse: axiosResponseParser
    });
}

export function improveAddress(params: any) {
    return request.put('/order/improveAddress', params)
}

export function close(params: any) {
    return request.put('/order/closeOrderDetail', params);
}

export function placeOrder(params: any) {
    return request.post('/sales/order/external', params);
}

export function meinianPullOrder() {
    return request.get('/sys/quartzJob/execute', {params: {jobClassName: 'com.fosun.dms.admin.job.MeinianPullOrderJob'}});
}

export function meinianNewPullOrderJob() {
    return request.get('/sys/quartzJob/execute', {params: {jobClassName: 'com.fosun.dms.admin.job.MeinianNewPullOrderJob'}});
}

export function meinianUploadSupply() {
    return request.get('/sys/quartzJob/execute', {params: {jobClassName: 'com.fosun.dms.admin.job.MeinianUploadsSupplyOrderJob'}});
}

export function meinianNewUploadsSupplyOrderJob() {
    return request.get('/sys/quartzJob/execute', {params: {jobClassName: 'com.fosun.dms.admin.job.MeinianNewUploadsSupplyOrderJob'}});
}


export function yunyigouPullOrder() {
    return request.get('/sys/quartzJob/execute', {params: {jobClassName: 'com.fosun.dms.admin.job.YunyigouPullOrderJob'}});
}

export function yunyigouUploadSupply() {
    return request.get('/sys/quartzJob/execute', {params: {jobClassName: 'com.fosun.dms.admin.job.YunyigouUploadsSupplyOrderJob'}});
}

export const getContracts = '/order/getContracts';

export function confirmOrderNew(orderId: string) {
    return request.post('/order/new/confirm', {orderId});
}

export function closeOrderNew(orderId: string) {
    return request.post('/order/new/close', {orderId});
}

export function closeOrderDetailNew(params: any) {
    return request.post('/order/new/close/detail', params);
}
